function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("title", null, "0988D775-9A01-440A-BE8E-B0425E3EDBFB@2x");

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "current",
  strokeWidth: 0,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Assets-for-exporting",
  transform: "translate(-57.000000, -194.000000)",
  stroke: "current",
  strokeWidth: 1.5
}, React.createElement("path", {
  d: "M66.3291503,195.106018 C66.598121,195.113175 66.659523,195.174577 66.6839693,195.252989 L66.6839693,195.252989 L68.3844383,200.707257 L74.0972293,200.639038 C74.16626,200.638213 74.2290896,200.665447 74.2748677,200.710145 C74.3206458,200.754842 74.3493723,200.817004 74.3501967,200.886035 C74.3511774,200.968163 74.3117549,201.045534 74.2447353,201.093014 L74.2447353,201.093014 L69.5828919,204.395718 L71.4131219,209.807824 C71.4352375,209.873221 71.428752,209.941392 71.4003882,209.998742 C71.3720244,210.056091 71.3217823,210.102621 71.256385,210.124737 C71.1785794,210.151048 71.092813,210.137464 71.0269463,210.088397 L71.0269463,210.088397 L66.4452996,206.675312 L61.863653,210.088397 C61.8082905,210.129639 61.7414525,210.144537 61.6781447,210.135283 C61.6148368,210.12603 61.555059,210.092625 61.5138169,210.037263 C61.4647496,209.971396 61.4511656,209.88563 61.4774774,209.807824 L61.4774774,209.807824 L63.3077074,204.395718 L58.645864,201.093014 C58.5895325,201.053106 58.5547099,200.994143 58.5439473,200.931074 C58.5331847,200.868005 58.546482,200.80083 58.5863903,200.744499 C58.6338707,200.677479 58.7112416,200.638057 58.7933699,200.639038 L58.7933699,200.639038 L64.506161,200.707257 L66.20663,195.252989 C66.2271776,195.187082 66.2724941,195.135743 66.3291503,195.106018 Z",
  id: "Star-Copy-42"
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "19px",
    height: "17px",
    viewBox: "0 0 19 17",
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/smallstar-empty.1ff42358.svg";
export { SvgComponent as ReactComponent };